/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  's-forbidden': {
    width: 19.98,
    height: 19.98,
    viewBox: '0 0 19.98 19.98',
    data: '<path pid="0" fill-rule="evenodd" d="M9.99 0A9.98 9.98 0 000 9.99a9.98 9.98 0 009.99 9.99 9.98 9.98 0 009.99-9.99A9.98 9.98 0 009.99 0zm0 15.47a5.484 5.484 0 01-5.485-5.485 5.48 5.48 0 015.485-5.48 5.484 5.484 0 015.485 5.485 5.48 5.48 0 01-5.485 5.48z" _fill="#df4545"/>'
  }
})
